import { ScrollTrigger } from "gsap/all";
import _ from "underscore";

export default class Header {

  constructor() {
    this.html = document.querySelector('html');
    this.header = document.querySelector('.header');
    this.contactBar = document.querySelector('.contact-bar');

    window.addEventListener('scroll', (event) => {
      this.scrollHandler();
    });
    this.scrollHandler()

    window.addEventListener('resize', (event) => {
      this.resizeHandler();
    });
    this.resizeHandler()
  }

  scrollHandler() {
    this.header.classList.toggle('has-scrolled', this.html.scrollTop > this.header.clientHeight - 40);
    this.html.style.setProperty('--header-height-current', this.header.clientHeight + 'px');

    // // scrolling up
    // if (this.html.scrollTop > this.threshold && this.lastScrollTop < this.html.scrollTop) {
    //   this.headerLogo.classList.add('-translate-y-[100px]');
    // }

    // // scrolling down
    // if (this.lastScrollTop > this.html.scrollTop) {
      //   this.headerLogo.classList.remove('-translate-y-[100px]');
    // }

    // save scroll position
    // this.lastScrollTop = this.html.scrollTop
  }

  resizeHandler() {
    this.html.style.setProperty('--header-height', this.header.clientHeight + 'px');
    if (this.contactBar) {
      this.html.style.setProperty('--contact-bar-height', this.contactBar.clientHeight - 16 + 'px');
    }

    _.debounce(() => {
      ScrollTrigger.refresh();
    }, 100);
  }

}
